import * as React from 'react';
// @ts-ignore
import { Column, Sort } from 'components/SmartTable';
import Radio from 'components/Radio';
import { setSort } from 'reducers/tables';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import invariant from 'invariant';

type Props = {
  column: Column;
  namespace: string;
  selectedSort: string;
  setSort: (namespace: string, sortKey: string) => any;
};

class SmartTableHeaderSorts extends React.Component<Props> {
  setColumnSort = (sortKey: string) => {
    this.props.setSort(this.props.namespace, sortKey);
  };
  render() {
    invariant(this.props.column.sorts, 'column must have sorts');

    const radios = this.props.column.sorts?.map((sort: Sort) => {
      const radio = (
        <Radio
          name="sort"
          label={sort.name}
          onChange={() => this.setColumnSort(sort.key)}
          checked={this.props.selectedSort === sort.key}
        />
      );
      if (sort.lastInSection) {
        return (
          <div className="SmartTableHeaderSorts-radio" key={sort.key}>
            {radio}
          </div>
        );
      } else {
        return radio;
      }
    });

    return (
      <div>
        <div className="SmartTableHeaderSorts-label">Sort by</div>
        {radios}
      </div>
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  return {
    selectedSort: state.tables.get(props.namespace).sort,
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ setSort }, dispatch);
}

export { SmartTableHeaderSorts };
export default connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(SmartTableHeaderSorts);
